import React, { Component } from 'react';
import { onFormInputKeyDown } from '../helpers/HelperFunctions';
import { v4 } from 'uuid';
export class FloatField extends Component {
    constructor(props) {
        super(props);
        const { value } = this.props;

        let newValue = value ? this.updateValue(value, this.props.accuracy ?? 2) : '';
        let newValueParts = newValue.split(',');
        if (newValueParts.length > 1) {
            newValue = newValueParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ',' + newValueParts[1];
        }

        this.state = {
            accuracy: this.props.accuracy ?? 2,
            value: newValue,
            id: v4()
        };
        this.handleChange = this.handleChange.bind(this);
        this.formatValue = this.formatValue.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }
    onKeyDown(e) {
        if ((e.key === '.' || e.key === ',') && this.state.value.includes(',')) {
            e.preventDefault();
            e.stopPropagation();
        }
        else {
            onFormInputKeyDown(e);
        }
    }
    componentDidUpdate() {
        if (this.props.canUpdate) {
            const value = this.props.value ? this.updateValue(this.props.value, this.state.accuracy) : '';
            const newValue = parseFloat(value ? value.replaceAll(' ', '').replace(',', '.') : '0');
            const oldValue = parseFloat(this.state.value ? this.state.value.replaceAll(' ', '').replace(',', '.') : '0');
            if (Math.abs(newValue - oldValue) > 0.000009) {
                let formatedValue = this.formatValue(value, { pos: 0 });
                this.setState({
                    value: formatedValue
                });
            }
        }
    }
    render() {
        const { name, disabled } = this.props;
        const { value, id } = this.state;
        return (
            <input
                id={id}
                name={name}
                value={value}
                className={`${this.props.className}` + (value && value.startsWith('-') ? ' negative' : '')}
                onBlur={this.onBlur}
                onChange={this.handleChange}
                onKeyDown={this.onKeyDown}
                disabled={disabled ? "disabled" : ""}
            />
        );
    }
    onBlur(e) {
        let { value, accuracy } = this.state;
        let oldValue = value ? value.slice() : '';
        value = this.updateValue(value, accuracy);
        if (this.props.showEmpty && /^[0,]+$/.test(value)) {
            value = '';
        }
        if (value !== oldValue) {
            e.target.value = value;
            this.setState({ value: value });
            if (this.props.onChange)
                this.props.onChange(e);
        }
    }
    updateValue(value, accuracy) {
        if (!value && this.props.showEmpty) {
            value = '';
            return value;
        }
        if (!value) {
            value = '0,';
            for (let i = 0; i < accuracy; i++) {
                value += '0';
            }
        }
        if (value.indexOf(',') === -1) {
            value += ',';
            for (let i = 0; i < accuracy; i++) {
                value += '0';
            }
        }
        else {
            let part1 = value.split(',')[0];
            if (!part1)
                part1 = '0';
            let part2 = value.split(',')[1];
            while (part2.length < accuracy)
                part2 += '0';
            value = part1 + ',' + part2;
        }
        return value;
    }
    handleChange(e) {
        const { value } = e.target;
        const { id } = this.state;
        let formatedValue = value.replaceAll(' ', '').replaceAll('.', ',');

        const pattern = this.props.onlyPositiove ? /^[0-9]{0,}[,]?[0-9]{0,}$/ : /^-?[0-9]{0,}[,]?[0-9]{0,}$/;

        if ((pattern).test(formatedValue) || !formatedValue) {
            let caretPos = { pos: e.target.selectionStart };
            formatedValue = this.formatValue(formatedValue, caretPos);
            e.target.value = formatedValue;
            this.setState({ value: formatedValue }, () => {
                let element = document.getElementById(id);
                element.setSelectionRange(caretPos.pos, caretPos.pos);
            });
            if (this.props.onChange)
                this.props.onChange(e);
        }
    }
    formatValue(value, caretPos) {
        const { accuracy } = this.state;

        let caretDif = 0;
        let stateValue = this.state.value.replaceAll(' ', '');
        const element = document.getElementById(this.state.id);
        if (value.indexOf(',') === -1) {
            let stateIndex = stateValue.indexOf(',');
            if (stateIndex !== -1 && value.slice(0, stateIndex) + ',' + value.slice(stateIndex) === stateValue) {
                if (value + ',' !== stateValue) {
                    value = this.state.value;
                }
                else
                    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            }
            else {
                while (value.length > 1 && value[0] === '0') {
                    value = value.substring(1);
                }
                value = value.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            }
        }
        else {
            let part1 = value.split(',')[0];
            if (part1) {
                while (part1.length > 1 && part1[0] === '0') {
                    part1 = part1.substring(1);
                }
            }
            else
                part1 = '0';

            let part2 = value.split(',')[1];
            if (part2.length > accuracy) {
                part2 = part2.slice(0, accuracy);
                caretDif++;
            }

            value = part1.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ',' + part2;
        }
        if (value !== this.state.value)
            caretDif += value.length - element.value.length;
        caretPos.pos += caretDif;
        caretPos.pos = Math.min(caretPos.pos, value.length);
        caretPos.pos = Math.max(caretPos.pos, 0);
        return value;
    }
}